export const PasswordValidationRegex = /^.{12,}$/;